import React from "react";
import { Link } from "react-router-dom";
import imgEngineering from "../../imagens/devProduto.png";
import imgProduction from "../../imagens/imgProduction.png";
import imgTooling from "../../imagens/imgTooling.png";
import logoPt from "../../imagens/logos/logoCapabilities.png";
import logoEn from "../../imagens/logos/logoCapabilitiesEnSSA.png";
import { useTranslation } from "react-i18next";
import "./chooseCapabilities.css";

function EngineerOrProduction() {
    const { t, i18n } = useTranslation();

    const capabilitiesLogo =
        i18n.language.startsWith("pt") ? logoPt : logoEn;


    return (
        <div>
            <div className="text-start mb-2 ms-2">
                <img
                    className="img-fluid img-custom-size"
                    src={capabilitiesLogo}
                    alt={t("chooseCapabilities.logoAlt")}
                />
            </div>

            <div className="engineerOrProduction pt-2">
                <div className="custom-width col-md-2 col-sm-3 mb-4 hover-custom mt-2">
                    <Link className="text-decoration-none" to="/Capabilities/Production">
                        <img
                            src={imgProduction}
                            className="img-fluid"
                            alt={t("chooseCapabilities.production")}
                        />
                        <h3 className="textCapabilities text-wrap text-center mt-2 s-md-5">
                            {t("chooseCapabilities.production")}
                        </h3>
                    </Link>
                </div>

                <div className="custom-width col-md-2 col-sm-3 mb-4 hover-custom mt-2">
                    <Link className="text-decoration-none" to="/Capabilities/Engineering">
                        <img
                            src={imgEngineering}
                            className="img-fluid"
                            alt={t("chooseCapabilities.engineering")}
                        />
                        <h2 className="textCapabilities text-wrap text-center mt-2 s-md-5">
                            {t("chooseCapabilities.engineering")}
                        </h2>
                    </Link>
                </div>

                <div className="custom-width col-md-2 col-sm-3 mb-4 hover-custom mt-2">
                    <Link className="text-decoration-none" to="/Capabilities/ToolingAndManufacturing">
                        <img
                            src={imgTooling}
                            className="img-fluid"
                            alt={t("chooseCapabilities.tooling")}
                        />
                        <h2 className="textCapabilities text-wrap text-center mt-2 s-md-5">
                            {t("chooseCapabilities.tooling")}
                        </h2>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default EngineerOrProduction;
